import { Helmet } from 'react-helmet';
import { MainHead } from '../../../components/common/head/MainHead';
import { AnimateLoading } from '../../../components/common/loading/AnimateLoading';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { newProductConstant } from '../../../constants/product/newProduct.constant';
import { ProductStatusConstant } from '../../../constants/product/product.constant';
import { useGetNewOpenMarketProductQuery } from '../../../hooks/api/product/queries/useGetNewOpenMarketProduct.query';
import { useGetOpenMarketProductsQuery } from '../../../hooks/api/product/queries/useGetOpenMarketProducts.query';
import { useMarkNotificationAsRead } from '../../../hooks/page/useMarkNotificationAsRead';
import { useLayout } from '../../../hooks/screen/useLayout';
import { useGetUserProfile } from '../../../hooks/user/useGetUserProfile';
import { OpenMarketProductListSummaryView } from '../../../views/Product/listView/OpenMarketProductListSummaryView/OpenMarketProductListSummaryView';
import { OpenMarketProductListSummaryViewGroup } from '../../../views/Product/listView/OpenMarketProductListSummaryView/OpenMarketProductListSummaryViewGroup';
import { MarketAlarmButton } from '../../Product/ProductListPage/components/MarketAlarmButton';
import { OpenMarketDescription } from './components/OpenMarketDescription';
import { OpenMarketListPageWrapper } from './components/OpenMarketListPageWrapper';
import { SellTractorButton } from './components/SellTractorButton';

export const OpenMarketListPage = () => {
  const { userProfile } = useGetUserProfile();
  useLayout({
    fixedHeader: (
      <>
        <MainHead backButton={{ isShow: false }} headerTitle={'회원 직거래'} hasMyInfoButton />
        <MarketAlarmButton pageType={'OLP'} />
      </>
    ),
    fixedHeaderHeight: userProfile?.advertisementTermsAgreement ? 40 : 78,
    fixedFooter: <SellTractorButton pageType={'olp'} />,
    fixedFooterHeight: 0,
  });

  const { data: products, isLoading: isGetProductsQueryLoading } = useGetOpenMarketProductsQuery({
    searchParam: { status: `${ProductStatusConstant.ONSALE},${ProductStatusConstant.SOLDOUT}` },
  });

  const { data: newOpenMarketProduct } = useGetNewOpenMarketProductQuery();
  useMarkNotificationAsRead(newOpenMarketProduct, newProductConstant.openMarket.key);

  if (isGetProductsQueryLoading) {
    return <AnimateLoading />;
  }

  if (products) {
    return (
      <>
        <Helmet>
          <title>{pageInfo.openMarketListPage.title}</title>
        </Helmet>

        <OpenMarketListPageWrapper>
          <OpenMarketDescription />

          <OpenMarketProductListSummaryViewGroup>
            {products &&
              products.map((product) => {
                return <OpenMarketProductListSummaryView key={product.id} product={product} />;
              })}
          </OpenMarketProductListSummaryViewGroup>
        </OpenMarketListPageWrapper>
      </>
    );
  }

  return <></>;
};
